// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-div[data-v-3fce4cab] {\n  min-height: calc(100vh - 64px);\n}", ""]);
// Exports
module.exports = exports;
